export const DummyWrapper = <T,>({ children }: { children: React.ReactNode } & T) => {
	return <>{children}</>;
};
